import { Component, ViewChild, ChangeDetectorRef, ElementRef, Input, ChangeDetectionStrategy, AfterViewChecked } from '@angular/core';
import { PhoneService } from '../../services/phone/phone.service';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx/';
import { PhoneCall } from '../../services/phone/phonecall';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MessageService, DialogService, ToastService } from '@wephone-utils';
import { ISentSmsModalData, SentSmsModalComponent } from '@wephone-sms/component/sent-sms-modal/sent-sms-modal';
import { QuickDialerComponent } from '@wephone-app-phone/dialer/quick-dialer/quick-dialer.component';
import * as _ from 'lodash';
import { IStoragePhoneCallingInfo, UserProfileService } from '@wephone/services/user-profile.service';
import { _ti } from '@wephone-translation';

@Component({
  selector: 'keypad',
  templateUrl: 'keypad.html',
  styleUrls: ['./keypad.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KeypadComponent implements AfterViewChecked {
  @Input() activeCall: PhoneCall;
  @Input() enabled = true;
  @ViewChild('number_input') numberInput;

  showQualify = false;
  typedNumber = '';
  private lastDialNumber: string;
  private hasOpenQuickDial: boolean;

  constructor(
    // private renderer: Renderer2,
    private elRef: ElementRef,
    private cdRef: ChangeDetectorRef,
    private phoneService: PhoneService,
    private deviceService: DeviceDetectorService,
    private toast: ToastService,
    public androidPermissions: AndroidPermissions,
    private readonly messageService: MessageService,
    private readonly dialogService: DialogService,
    private readonly userProfiles: UserProfileService,
  ) {
    phoneService.dialingNumberChanges.subscribe(
      newNumber => {
        this.cdRef.markForCheck();
        this.cdRef.detectChanges();
      }
    );

    this.messageService.subscribe('show_qualify', status => {
      this.showQualify = status;
    });
  }

  get phoneNumber(): string {
    return this.phoneService.getDialingNumber() || '';
  }

  set phoneNumber(val: string) {
    this.phoneService.setDialingNumber(val);
    this.cdRef.markForCheck();
    this.cdRef.detectChanges();
  }

  openQuickDial(): void {
    this.hasOpenQuickDial = true;
    this.dialogService.openDialog2(QuickDialerComponent, {
      padding: false
    }, ret => {
      this.hasOpenQuickDial = false;
      // console.log('ret openQuickDial', ret);
      if (ret && ret.phone_number) {
        this.setPhoneNumber(ret.phone_number);
        this.makeCall();
      }
    });
  }

  handleKeyboardEvent(event: KeyboardEvent): void {
    // console.log('keycode', event.keyCode);
    // If press Up Arrow
    if ((event.keyCode === 38) && !this.hasOpenQuickDial) {
      this.openQuickDial();
    }

    // If press Enter
    if ((event.keyCode === 13) && this.phoneNumber && !this.activeCall) {
      this.makeCall();
    }
    const srcElement = event.srcElement as HTMLElement;
    const tagName = srcElement.tagName && srcElement.tagName.toLowerCase();
    if (tagName && ['input', 'textarea'].indexOf(tagName) >= 0) {
      return;
    }
    if (event.keyCode === 8) {
      this.delDigit();
    }
    /*
        if (this.phoneNumber.length < 14 && ((event.keyCode >= 96 && event.keyCode <= 105)
          || event.keyCode === 107 || event.keyCode === 106)) {
          this.setPhoneNumber(this.phoneNumber + event.key);
        }
    */
    if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) {
      this.phoneNumber += event.key;
      this.setFocus(this.numberInput);
    }
  }

  setFocus(element: ElementRef): void {
    setTimeout(() => {
      element.nativeElement.selectionStart = element.nativeElement.selectionEnd = 10000;
      element.nativeElement.focus();
    });
  }

  focus(): void {
    this.elRef.nativeElement.focus();
  }

  addDigit(digit: string): void {
    if (this.activeCall) {
      this.typedNumber = `${digit}${this.typedNumber}`;
      this.activeCall.dtmf(digit);
    } else if (this.phoneNumber.length < 20) {
      this.setPhoneNumber(this.phoneNumber + digit);
    }
  }

  delDigit(): void {
    if (this.phoneNumber) {
      this.setPhoneNumber(this.phoneNumber.slice(0, -1));
    }
  }

  clearNumber(): void {
    this.setPhoneNumber('');
  }

  setPhoneNumber(phone_number: string): void {
    this.phoneService.setDialingNumber(phone_number);
  }

  async makeCall(): Promise<void> {
    if (!this.phoneNumber && this.lastDialNumber) {
      this.phoneNumber = this.lastDialNumber;
      return;
    }

    const callingInfo: IStoragePhoneCallingInfo = await this.userProfiles.getPhoneCallingInfo();

    this.lastDialNumber = this.phoneNumber;
    if (!callingInfo.calling_number) {
      this.toast.showError(_ti('call.message.no_calling_number'));
      return;
    }

    this.phoneService.makeCall(this.phoneNumber, callingInfo.calling_number, callingInfo.calling_queue_id);
  }

  sendSMS(): void {
    const data: ISentSmsModalData = { destination: this.phoneNumber };
    this.dialogService.openDialog2(SentSmsModalComponent, {
      data
    }, ret => {
      // console.log('ret', ret);
    });
  }

  isMobileDevice(): boolean {
    return this.deviceService.isMobile();
  }

  ngAfterViewChecked(): void {
    if (this.showQualify) {
      return;
    }
  }
}
